import { ArrowRight, Warning } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { Button } from "@/components/ui/button";
import { isValidLang, type Lang, ROUTE_SLUGS } from "@/config/routes";

type Props = {
	count: number;
};

export function AlertsBanner({ count }: Props) {
	const { t } = useTranslation();
	const { lang } = useParams<{ lang: string }>();
	const navigate = useNavigate();
	const l: Lang = lang && isValidLang(lang) ? lang : "pl";

	if (count === 0) return null;

	return (
		<div className="flex flex-wrap items-center justify-between gap-4 rounded-lg border border-red-200/60 bg-red-50/60 p-4 dark:border-red-900/60 dark:bg-red-950/20">
			<div className="flex items-center gap-3">
				<div className="flex size-10 items-center justify-center rounded-md border border-red-200 bg-white text-red-600 dark:border-red-900 dark:bg-red-950/50 dark:text-red-400">
					<Warning className="size-5" aria-hidden="true" />
				</div>
				<p className="text-foreground font-semibold">
					{t("dashboard.alertsBanner.title", { count })}
				</p>
			</div>
			<Button
				variant="destructive"
				onClick={() => navigate(`/${l}/${ROUTE_SLUGS.alerts[l]}`)}
			>
				<ArrowRight aria-hidden="true" />
				{t("dashboard.alertsBanner.cta")}
			</Button>
		</div>
	);
}
